// extracted by mini-css-extract-plugin
export var container = "_sl-0";
export var dotAnimation = "_sl-2";
export var dotsLoading = "_sl-1";